import type { VariantProps } from "class-variance-authority"
import * as React from "react"
import { cva } from "class-variance-authority"

import { cn } from "@/domains/library"

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>

const inputVariants = cva(
  cn(
    "flex w-full rounded-md text-sm focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
    "file:border-0 file:bg-transparent file:text-sm file:font-medium ",
    "border border-p400 hover:border-p400-light focus-visible:border-p400-light",
    "placeholder-t300 placeholder-opacity-100",
    "focus-visible:ring-2 focus-visible:ring-ring/[0.28]",
  ),
  {
    variants: {
      variant: {
        default: "bg-p400 text-t100 ",
        dialog: "bg-p400 text-t300",
        p300: "bg-p300 text-t100",
        transparent: "border-0 bg-transparent text-t100 text-t300 focus-visible:border-0 focus-visible:ring-0",
      },
      layout: {
        default: "h-10 px-3 py-2",
        dialog: "max-h-[40px] px-3 py-1.5",
      },
    },
    defaultVariants: {
      variant: "default",
      layout: "default",
    },
  },
)

const Input = React.forwardRef<HTMLInputElement, InputProps & VariantProps<typeof inputVariants>>(
  ({ className, type, variant, layout, ...props }, ref) => (
    <input type={type} className={cn(inputVariants({ variant, layout }), className)} ref={ref} {...props} />
  ),
)
Input.displayName = "Input"

export { Input }
